import { livisAlert } from "../helpers/alert";
import { axios } from "../helpers/axios";
import { setNoAlertStatus } from "../helpers/storage";
import { doesUserHasAccess } from "../helpers/utils";
export type UniqueUsecasePaload = {
  usecase_name: string;
  workstation_id?: string;
};

// API for fetching usecases along with filters
export const getAllUsecase = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post(`usecase/get_all_usecases/`, payload);
};
// API for fetching usecases along with filters
export const getAllUsecaseForWorkstation = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.get(`usecase/get_all_usecases_for_workstation/${payload}`);
};

// API for check unique usecase name
export const checkUniqueUsecaseName = (
  payload: UniqueUsecasePaload
): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post("usecase/check_usecase_uniqueness/", payload, {
    suppressAlerts: { statusCode: [422] },
  } as any);
};

// API for adding usecase
export const addUsecase = (payload: any): Promise<any> => {
  return axios.post("usecase/add_usecase/", payload);
};

// API for deleting an Usecase
export const deleteUsecase = (id: string): Promise<any> => {
  return axios.delete(`usecase/delete_usecase/${id}`);
};

// API for updating/editing usecase
export const editUsecase = (payload: any): Promise<any> => {
  return axios.patch(`usecase/update_usecase/`, payload);
};

// API for changing usecase status
export const changeUsecaseStatus = (payload: any): Promise<any> => {
  return axios.get(`usecase/update_usecase_status/${payload}`);
};

export const getParametersByTag = (payload: any): Promise<any> => {
  return axios.post(`parameters/get_parameters_by_tag/`, payload, {
    suppressAlerts: { statusCode: [403] },
  } as any);
};

// API for searching parameters
export const getAllParameters = (payload: any): Promise<any> => {
  return axios.post(`parameters/get_all_parameters/`, payload, {
    suppressAlerts: { statusCode: [403] },
  } as any);
};

// API for Adding parameter in kanban
export const createParameter = (payload: any): Promise<any> => {
  return axios.post(`parameters/create_parameter/`, payload, {
    suppressAlerts: { statusCode: [403] },
  } as any);
};

//API for getting usecase statistics
export const getUsecaseStatistics = (id: any): Promise<any> => {
  return axios.get(`usecase/get_usecase_analytics/${id}`);
};

//API or getting all tags
export const getAllTagsAPI = (payload: any): Promise<any> => {
  const hasAccess = doesUserHasAccess(139);
  if (!hasAccess) {
    livisAlert("You dont have access to get all tags", "warning");
    return Promise.reject(new Error("No access to get all tags"));
  }

  const { current, limit_to, tag } = payload || {};
  let url = `usecase/get_all_tags/?current=${current}&limit_to=${limit_to}`;

  if (tag) {
    url += `&tag=${tag}`;
  }

  return axios.get(url);
};

// API to get parent tag type with optional tag parameter
export const getParentTagTypeAPI = (type: any, tag?: any): Promise<any> => {
  let url = `usecase/get_parent_tag/?tag_type=${type}`;

  if (tag) {
    url += `&tag=${tag}`;
  }

  return axios.get(url);
};

//API to get parent tag type
export const searchTagAPI = (value: any): Promise<any> => {
  return axios.get(`usecase/search_tag/?tag=${value}`);
};

// API to get usecase tags in add usecase
export const getAllTagsByParentAPI = (
  type: any,
  value: any,
  current: any,
  limit_to: any,
  created_by: any = null
): Promise<any> => {
  console.log(type);
  let url = `usecase/get_tag_by_parent_id/?parent_id=${type}`;
  if (value) {
    url += `&tag=${value}`;
  }
  if (current) {
    url += `&current=${current}`;
  }
  if (limit_to) {
    url += `&limit_to=${limit_to}`;
  }
  if (created_by) {
    url += `&created_by=${created_by}`;
  }
  return axios.get(url);
};

// API to delete tag
export const deleteTagAPI = (id: string): Promise<any> => {
  return axios.delete(`usecase/delete_tag/${id}`);
};

//API to get all tag creators
export const getAllCreatorsAPI = (): Promise<any> => {
  return axios.get(`usecase/get_all_tag_creators/`);
};

// API for verify parameters
export const verifyParameters = (payload: any): Promise<any> => {
  return axios.post(`/parameters/verify_parameter/`, payload);
};

export const getUsecaseDrift = (usecaseId: string): Promise<any> => {
  return axios.get(`usecase/get_usecase_drift/?usecase_id=${usecaseId}`);
};

// Single aggregated stats call for the sidebar tiles (training data count,
// data analytics score, best training score, evaluation count, trash count)
// so the sidebar no longer has to hit every module's own listing API just to
// fill in a few numbers. v2 endpoint — path is hardcoded, no version prefix helper.
export const getUsecaseSidebarStats = (usecaseId: string): Promise<any> => {
  return axios.get(`/livis/v2/usecase/get_usecase_sidebar_stats/${usecaseId}`);
};
